<template>
    <div slot="content">
        <div class="talbe-contain" style="display: flex;border: 1px solid #a6acb1;border-radius: 3px;">
            <div class="table-area" style="margin-right: 20px; width: 30%;">
                <div class="table-b">
                    <el-tree class="custom-tree" :data="data" :props="defaultProps" @node-click="handleNodeClick" default-expand-all></el-tree>
                </div>
            </div>
            <div class="table-area" style="margin-right: 50px; width: 70%">
                <div class="table-b">
                    <ag-grid-vue 
                    style="width: 100%; height: 330px;"
                    class="ag-theme-alpine"    
                    row-selection="single"
                            
                    :column-defs="columnDefs"     
                    :grid-options="gridOptions"
                    :row-data="rowData"
                    :default-col-def="defaultColDef"
                    @rowDoubleClicked="rowDoubleClick"
                    @grid-ready="onGridReady"
                    @cell-clicked="onCellClicked" />
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
/**
 * * components
 */

import {AgGridVue} from 'ag-grid-vue';

function getTreeData(array){
    var map = {};
    for(var i = 0; i < array.length; i++){
        var obj = {"id" : array[i]['id'], "label" : array[i]['catKeyNm'], "catKey" : array[i]['catKey'], "LVL" : array[i]['lev']};
        obj.children = [];
        map[obj.id] = obj;
        var parent = array[i]['topKey'] || '-';

        if(!map[parent]){
            map[parent] = {
                children: []
            };
        }
        map[parent].children.push(obj);
    }

    return map['-'].children;
}

export default {
    props: {
        tabData: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        }
    },
    components: {AgGridVue},
    data() {
        return {
            // AG-GRID OPTION [START]
            rowData:[],
            gridOptions: {},
            columnDefs:[
                {
                    headerName:'No.', 
                    field:'no', 
                    width:80,
                    valueFormatter: function(params) {
                        return params.node.rowIndex+1;
                    }
                },
                {
                    headerName: '대표모델', 
                    field:'standardModelNm',
                    width: 140, 
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '모델', 
                    field:'modelNm', 
                    width: 200,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '제조번호', 
                    field:'serialNo', 
                    width: 150,
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '설치일자', 
                    field:'setupDt', 
                    width: 150,
                    cellStyle:{textAlign:'center'}
                },
                {
                    headerName: '보증기간', 
                    headerClass: 'header-rowspan-2',
                    children: [{
                        headerName: '시작일',
                        field: 'guaranteeStartDt',
                        headerClass: 'hide-cell',
                        width: 110
                    },{
                        headerName: '종료일',
                        field: 'guaranteeEndDt',
                        headerClass: 'hide-cell',
                        width: 110
                    }]
                },                        
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            // el-tree data
            /*
            data: [{
                label: '전체',
                catKey: '',
                children: [{
                    label: '대우루컴즈',
                    catKey: '',
                    children: [{
                        label: '모니터',
                        catKey: '',
                        children: [{
                            label: 'LCD(일반)',
                            catKey: '',
                        }]
                    }]
                }]
            }],
            */
            data: [],
            defaultProps: {
                children: 'children',
                label: 'label',
                catKey: 'catKey'
            },
            form: {
                custId: '0',
                siteId: '0'
            }
        }
    },
    mounted() {
        console.log('hasmodel start=====tabData=', this.tabData)
        this.form = this.tabData[0] ? this.tabData[0].param : {}

        this.goOpen('')
    },
    methods: {
        handleNodeClick(data) {
            const vModelGroup = data.LVL < 2 ? '' : data.catKey // 전체, 회사명일경우 공백으로 조회
            this.goOpen(vModelGroup)
            console.log('handleNodeClick: ', data);
        },
        onGridReady(){
            
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        onCellClicked(event) {
            this.$emit('onCellClicked', event);
        },
        goOpen(vModelGroup){
            this.$store.commit('loading');
            
            const vform = {
                companyId: this.$store.state.loginInfo.compCd || '',
                custId: this.form.custId || '0',
                siteId: this.form.siteId || '0',
                modelCd: '',
                maker: this.form.maker || '',
                modelGroup:  vModelGroup,
                standardModelNm: this.form.standardModelNm || '',
                modelNm: this.form.modelNm || '',
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            };
            console.log('hasModal vform: ', vform);
            this.$http.post(("/api/asMng/popup/siteModelSelect/searchModelAddList"), vform
                ).then(response => {
                
                if(response.data.callUspSiteModelFindPageList){
                    this.rowData = response.data.callUspSiteModelFindPageList.map(x => {
                        if(x.setupDt != null && x.setupDt){
                            if(x.setupDt.length >=10){x.setupDt = x.setupDt.substring(0,10)}
                        }

                        if(x.guaranteeStartDt){
                            if(x.guaranteeStartDt.length >=10){x.guaranteeStartDt = x.guaranteeStartDt.substring(0,10)}
                        }

                        if(x.guaranteeEndDt){
                            if(x.guaranteeEndDt.length >=10){x.guaranteeEndDt = x.guaranteeEndDt.substring(0,10)}
                        }

                        if(x.prodDt){
                            if(x.prodDt.length >=10){x.prodDt = x.prodDt.substring(0,10)}
                        }

                        if(x.purchaseDt){
                            if(x.purchaseDt.length >=10){x.purchaseDt = x.purchaseDt.substring(0,10)}
                        }
                        const vModelInfo = {
                            companyId : x.companyId, deleteYn: x.deleteYn, guaranteeEndDt: x.guaranteeEndDt,
                            guaranteeMonth: x.guaranteeMonth, guaranteeStartDt: x.guaranteeStartDt, maker: x.maker,
                            makerNm: x.makerNm, modelCd: x.modelCd, modelGroup: x.modelGroup, modelGroupNm: x.modelGroupNm,
                            modelId: x.modelId, modelNm: x.modelNm, prodDt: x.prodDt, purchaseDt: x.purchaseDt,
                            serialNo: x.serialNo, setupDt: x.setupDt, siteId: x.siteId, siteModelId: x.siteModelId,
                            standardModelNm: x.standardModelNm
                        }
                        return vModelInfo
                    });
                }
                
                // console.log('model this.rowData aaa: ', this.rowData)
                if(response.data.callUspSiteModelGroupSelList){
                    let siteModel = response.data.callUspSiteModelGroupSelList
                    
                    console.log('siteModel: ', siteModel, this.data)
                    siteModel.unshift({lev:'0', topKey:'', topKeyNm:'', catKey:'', catKeyNm:'전체'})
                    siteModel.map((x,index)=>{
                        x.id = index === 0 ? 'root' : x.catKey // 주의 : id값에 문자도 포함되어야 함.
                        x.topKey = index > 0 && x.topKey === '' ? 'root' : x.topKey
                        
                        return x
                    })
                    
                    // console.log('siteModel2: ', siteModel)

                    /** tree생성 샘플 데이타 예시 
                     * 주의 : id는 문자도 포함되어 있어야 함.
                    siteModel = [{id:'root', lev:'1',   topKey:'', catKeyNm:'전체'},
                                {id:'ID2', lev:'2',   topKey:'root', catKeyNm:'대우'},
                                {id:'ID3', lev:'3',   topKey:'ID2', catKeyNm:'모니터1'},
                                {id:'ID4', lev:'3',   topKey:'ID2', catKeyNm:'모니터2'},
                                {id:'ID5', lev:'2',   topKey:'root', catKeyNm:'삼성'},
                                {id:'ID6', lev:'3',   topKey:'ID5', catKeyNm:'모니터1'}
                                ]
                     */

                    this.data = getTreeData(siteModel)
                    console.log('siteModel3: ', this.data )
                    
                }
                
            }).finally(() => {
                this.$store.commit('finish')
 
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.ag-header-cell.hide-cell,
.ag-header-group-cell.hide-cell {
display: none;
}
.ag-header-cell.header-rowspan-2 {
    top: -57px;
}
.ag-cell {
    padding-left: 10px;
    padding-right: 10px;
    &.hide-cell {
      display: none;
    }
}
</style>

